import { NavLink } from 'react-router';
import { useAuth } from '@/auth/AuthContext';
import { contactEmail } from '@/config/contact';
import { useSiteSettings } from '@/hooks/useSiteSettings';

/** Public-facing site footer. */
export function Footer() {
  const { isAdmin } = useAuth();
  const { settings } = useSiteSettings();

  return (
    <footer className='tw:border-t tw:border-ed-umber/30 tw:bg-ed-black tw:px-6 tw:py-16 tw:text-ed-cream'>
      <div className='tw:mx-auto tw:max-w-6xl'>
        <div className='tw:mb-12 tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-8 tw:md:flex-row'>
          <div className='tw:flex tw:items-center tw:gap-4'>
            <img src='/eightydays_balloon.png' alt='Eighty Days' className='tw:h-10 tw:w-auto tw:object-contain' />
            <span className='tw:flex tw:flex-col'>
              <span className='tw:font-serif tw:text-xl tw:tracking-wider tw:uppercase'>Eighty Days</span>
              <span className='tw:text-[0.625rem] tw:tracking-[0.2em] tw:uppercase tw:text-ed-gold/70'>
                Exclusive Experiences
              </span>
            </span>
          </div>

          <div className='tw:flex tw:gap-8 tw:text-sm tw:text-ed-cream/60'>
            <NavLink to='/catalog' className='tw:transition-colors tw:hover:text-ed-gold'>
              All Experiences
            </NavLink>
            {/* Unlike the header, no admin exception here: the footer is a
                courtesy link, and one showing a section partners cannot reach
                would only be a second place to keep in step. */}
            {settings.tourLeadersVisible && (
              <NavLink to='/tour-leaders' className='tw:transition-colors tw:hover:text-ed-gold'>
                Tour Leaders
              </NavLink>
            )}
            <NavLink to='/privacy' className='tw:transition-colors tw:hover:text-ed-gold'>
              Privacy
            </NavLink>
            <a href={`mailto:${contactEmail}`} className='tw:transition-colors tw:hover:text-ed-gold'>
              Contact
            </a>
          </div>
        </div>

        <div className='tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-4 tw:border-t tw:border-ed-umber/30 tw:pt-8 tw:text-xs tw:text-ed-cream/40 tw:md:flex-row'>
          <p>© {new Date().getFullYear()} Eighty Days Inc. All rights reserved.</p>
          {isAdmin && (
            <NavLink to='/admin' className='tw:text-ed-cream/30 tw:transition-colors tw:hover:text-ed-gold'>
              Admin
            </NavLink>
          )}
        </div>
      </div>
    </footer>
  );
}
